import React from "react";

const HesabimLoader = () => {
  return (
    <div className="containerMain animate-pulse gap-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="left-area col-span-1  h-[1800px] rounded-2xl">
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-4"></div> 
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-2"></div>
          <div className="h-full w-full bg-gray-100 rounded-2xl mb-2"></div>
          <div className="h-full w-full bg-gray-100 rounded-2xl"></div> 
        </div>
        <div className="right-area col-span-2">
          <div className=" w-full bg-gray-100 rounded-2xl mb-4 h-[242px]"></div>
          <div className="grid grid-cols-2 gap-4 h-[214px]">
            <div className="bg-gray-100 rounded-2xl h-[214px]"></div>
            <div className="bg-gray-100 rounded-2xl h-[214px]"></div>
          </div>
          <div className="w-full bg-gray-100 rounded-2xl my-4 h-[158px]"></div>
          <div className="w-full bg-gray-100 rounded-2xl my-4 h-[186]"></div>
          <div className=" w-full bg-gray-100 rounded-2xl h-[1000px]"></div>
        </div>
      </div>
    </div>
  );
};

export default HesabimLoader;
